import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ProductModalContextType {
  showProductModal: boolean;
  openProductModal: () => void;
  closeProductModal: () => void;
  isNewProduct: boolean;
  setIsNewProduct: (value: boolean) => void;
}

const ProductModalContext = createContext<ProductModalContextType | undefined>(undefined);

export const ProductModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showProductModal, setShowProductModal] = useState(false);
  const [isNewProduct, setIsNewProduct] = useState(false);

  const openProductModal = () => {
    setShowProductModal(true);
  };

  const closeProductModal = () => {
    setShowProductModal(false);
    setIsNewProduct(false);
  };

  return (
    <ProductModalContext.Provider 
      value={{ 
        showProductModal, 
        openProductModal, 
        closeProductModal,
        isNewProduct,
        setIsNewProduct
      }}
    >
      {children}
    </ProductModalContext.Provider>
  );
};

export const useProductModal = () => {
  const context = useContext(ProductModalContext);
  if (context === undefined) {
    throw new Error('useProductModal must be used within a ProductModalProvider');
  }
  return context;
};
